module.exports = __webpack_public_path__ + "img/telescope.f1ebb19b.svg";